import idRe from '../lib/id'
import { checkReserved, getWs } from '../lib'

const typeRe = /(?:let|const|var|class|function\s*\*?|async +function)/

/*
- export const abc
- export class ABC {}
- export function () {}
- export async function () {}
*/

/** @type {_restream.Rule} */
const detectRule = {
  re: new RegExp(
    `^( *export\\s+?)( *${typeRe.source}\\s+((?:${idRe.source}\\s*,?\\s*)+))`, 'gm'
  ),
  replacement,
}

/**
 * @suppress {globalThis}
 * @type {_alamode.ÀLaModeReplacer}
 */
function replacement(match, exportSeg, whatSeg, name) {
  const n = name.split(/,\s*/)
  n.forEach(nn => {
    const nt = nn.trim().replace(/\s+extends\s+.+/, '')
    checkReserved(nt)
    this.emit('export', { [nt]: nt })
  })
  if (this.noSourceMaps) return whatSeg
  const ws = getWs(exportSeg, false)
  return `${ws}${whatSeg}`
}

export default detectRule

/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('restream').Rule} _restream.Rule
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaModeReplacer} _alamode.ÀLaModeReplacer
 */